<template>
    <el-dialog 
    :modal-append-to-body="false"
    :title="'修改登录密码'"
    :visible.sync="visible"
    width="600px"
    :before-close="handleClose"
    custom-class="customModal">
    
    <el-form :model="ruleForm"  :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm" style="padding: 0px 15px 0 4px">
        <el-form-item label="旧密码" prop="old_password">
            <el-input type="password" v-model="ruleForm.old_password" auto-complete="off" />
        </el-form-item>
        <el-form-item label="新密码" prop="password">
            <el-input type="password" v-model="ruleForm.password" auto-complete="off" />
        </el-form-item>
        <el-form-item label="确认密码" prop="password_r">
            <el-input type="password" v-model="ruleForm.password_r" auto-complete="off" />
        </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submit">提交</el-button>
        <el-button @click="close">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { UserCenterService } from '../../../service/userCenter.service'
  export default {
    data() {
        var validatePass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入密码'));
            } else {
                if (this.ruleForm.password_r !== '') {
                this.$refs.ruleForm.validateField('password_r');
                }
                callback();
            }
        };
        var validatePass2 = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请再次输入密码'));
            } else if (value !== this.ruleForm.password) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        };
      return {
        visible: false,
        openType: '',
        ruleForm: {
            old_password: '',
            password: '',
            password_r: ''
        },
        rules: {
          old_password:[
            { required:true,message: '请输入旧密码',trigger: 'blur' },
          ],
          password: [
            { required: true,validator: validatePass, trigger: 'blur' }
          ],
          password_r: [
            { required: true,validator: validatePass2, trigger: 'blur' }
          ]
        },
      }
    },
    methods: {
      async open() {
        this.visible = true;
      },
      async submit() {
          const result = await this.$refs.ruleForm.validate()
          if(result) {
              const data = await UserCenterService.pwdChange(this.ruleForm)
              this.$emit('submitSuccess',data)
              this.close();
          }
      },
      close() {
        this.ruleForm = {}
        this.visible = false
      },
      handleClose() {
        this.close()
      },
    },
    created() {
    }
  }
</script>

<style lang="scss" scoped>

.treeTable {
  height: 29vw;
  overflow-y: auto;
  overflow-x: hidden;
}

</style>

<style lang="scss">
  .formItemFill .el-dialog__wrapper{
    z-index: 2500!important;
  }
  .rotationChart{
    .el-dialog__wrapper{
      .upload.formItemFill{
        height: 8vw;
        position: relative;
        .el-upload-list__item{
          margin-top: 0;
        }
        .el-button{
          position: absolute;
          top: 0px;
          left: 120px;
        }
      }
      .bg_color.formItemFill{
        height: 8vw;
        .el-color-picker__trigger{
          width: 100%;
          height: 93px;
          margin-top: -3px;
          .el-color-picker__icon{
            display: none;
          }
        }
      }
    }
  }
  .imgBox{
    text-align: left;
    border: 1px solid #e6e6e6;
    height: 6.2vw;
    img{
      height: 6.2vw;
    }
  }
</style>